import * as model from "../models";
import { TicketQuotaActions, EventActions, BoxOfficeActions } from "../actions"

let uuid = require('uuid');

export interface TicketQuotaState {
	loaded: boolean;
	loading: boolean;
	errors: boolean;
	collectionUrl: string;
	selectedTicketQuota: model.TicketQuota;
	ticketQuotaInEdit: model.TicketQuota;
	ticketQuotaCollection: model.TicketQuota[];
	ticketQuotaMessages: model.TicketQuotaMessage[];
};

const initialState: TicketQuotaState  = {
	loaded: false,
	loading: false,
	errors: false,
	collectionUrl: null,
	selectedTicketQuota: null,
	ticketQuotaInEdit: null,
	ticketQuotaCollection: [],
	ticketQuotaMessages: []
}

export const ticketQuotaReducer = (state: TicketQuotaState = initialState, action): TicketQuotaState => {
	switch (action.type) {
		case TicketQuotaActions.SET_SELECTED_TICKETQUOTA:
		case BoxOfficeActions.SET_SELECTED_TICKETQUOTA_BO:
			return {
				loaded: false,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: action.payload,
				ticketQuotaInEdit: null,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.LOAD_COLLECTION:
			return {
				loaded: false,
				loading: true,
				errors: false,
				collectionUrl: null,
				selectedTicketQuota: null,
				ticketQuotaInEdit: null,
				ticketQuotaCollection: [],
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.LOAD_COLLECTION_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: action.payload._links.self.href,
				selectedTicketQuota: null,
				ticketQuotaInEdit: null,
				ticketQuotaCollection: [...action.payload._embedded.ticketQuotas],
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.REFRESH_COLLECTION:
			return {
				loaded: false,
				loading: true,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case TicketQuotaActions.REFRESH_COLLECTION_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: [...action.payload._embedded.ticketQuotas],
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case TicketQuotaActions.CREATE_TICKETQUOTA_SUCCESS:
			return {
				loaded: false,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: action.payload,
				ticketQuotaInEdit: action.payload,
				ticketQuotaCollection: [...state.ticketQuotaCollection, ...action.payload],
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.UPDATE_TICKET_QUOTA_SUCCESS:
			return {
				loaded: false,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: action.payload,
				ticketQuotaInEdit: action.payload,
				ticketQuotaCollection: state.ticketQuotaCollection.map(ticketQuota => ticketQuota.uuid === action.payload.uuid ? action.payload : ticketQuota),
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case TicketQuotaActions.DELETE_TICKET_QUOTA:
			return {
				loaded: false,
				loading: true,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: null,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case TicketQuotaActions.DELETE_TICKET_QUOTA_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: null,
				ticketQuotaInEdit: null,
				ticketQuotaCollection: state.ticketQuotaCollection.filter(ticketQuota => ticketQuota.uuid != action.payload.uuid),
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.SET_TICKET_QUOTA_IN_EDIT:
			return {
				loaded: false,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: action.payload,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case TicketQuotaActions.LOAD_TICKETQUOTA_MESSAGES:
			return {
				loaded: false,
				loading: true,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: []
			}

		case TicketQuotaActions.LOAD_TICKETQUOTA_MESSAGES_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: [...action.payload]
			}

		case TicketQuotaActions.RELOAD_TICKETQUOTA_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection.map(ticketQuota => ticketQuota.uuid === action.payload.uuid ? action.payload : ticketQuota),
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case BoxOfficeActions.REFRESH_SELECTED_TICKETQUOTA_BO:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: action.payload,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection.map(ticketQuota => ticketQuota.uuid === action.payload.uuid ? action.payload : ticketQuota),
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case EventActions.UPDATE_EVENT_HAS_VISUAL_QUOTA_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				collectionUrl: state.collectionUrl,
				selectedTicketQuota: state.selectedTicketQuota,
				ticketQuotaInEdit: state.ticketQuotaInEdit,
				ticketQuotaCollection: state.ticketQuotaCollection,
				ticketQuotaMessages: state.ticketQuotaMessages
			}

		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		default: return state

	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/ticket-quota.reducer.ts